// extracted by mini-css-extract-plugin
export var colorSquare = "_nx-0";
export var danger = "_nx-5";
export var lightPink = "_nx-8";
export var neutralBlue = "_nx-7";
export var neutralYellow = "_nx-6";
export var normal = "_nx-1";
export var primary = "_nx-2";
export var primaryLight = "_nx-3";
export var solidBlack = "_nx-g";
export var solidGreen = "_nx-b";
export var solidLightBlue = "_nx-d";
export var solidNavy = "_nx-c";
export var solidOrange = "_nx-f";
export var solidPink = "_nx-e";
export var solidRed = "_nx-9";
export var solidYellow = "_nx-a";
export var success = "_nx-4";